import { removeToken, setUserInfo, getUserInfo, setSystemRole, setLastProjectId, setFactorInfo } from '@/utils/auth'
const user = {
  state: {
    userInfo: getUserInfo(),
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      setUserInfo(JSON.stringify(userInfo))
    }
  },

  actions: {
    // 登出
    LogOut({ commit, state }) {
      removeToken();
      setUserInfo(null)
      sessionStorage.setItem(process.env.VUE_APP_NODE_ENV + "lastSecondRouters", null)
      sessionStorage.setItem(process.env.NODE_ENV + "buttonPage", null)
      setSystemRole('')
      setLastProjectId('')
      setFactorInfo('')
      location.href = location.origin + location.pathname + "#/login"
      location.reload();
    }
  }
}

export default user
